export default __webpack_public_path__ + "static/media/3.709d2995.png";